import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { isMobile } from 'react-device-detect'
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import EpiContext from '@episerver/spa-core/Spa';
import { connect } from 'react-redux';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'
import { showAppLoader } from 'app/Components/Shared/Loader/LoaderSlice';
import { replacePlaceholders } from '../../../../utilities/StringHelpers/TitleHelpers';

const GeneralMessage = ({ messageData, buttonClick, data, userDetails, authentication, showAppLoader }) => {
    const { icon, title, secondTitle, buttonText, secondButtonText, report } = messageData;

    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            dwhReportOnLoad()
        }
    }, []);

    function dwhReportOnLoad() {
        if (report) {
            switch (report) {
                case 'generalError':
                    dwhGeneralReport({
                        data: { ...data, userDetails: authentication.loginData },
                        actionType: DwhActionType.ErrorScreen,
                        messageText: DWHMessageText.GeneralError,
                        status: DWHStatus.Error,
                    });
                    break;

                case 'successPageCellular':
                case 'successPageStationary':
                    dwhGeneralReport({
                        data: { ...data, userDetails: authentication.loginData },
                        actionType: DwhActionType.SuccessScreen,
                        messageText: DWHMessageText.SuccessScreenCellularInternet,
                        status: DWHStatus.Completed,
                    });
                    break;
                case 'successPageTv':
                    dwhGeneralReport({
                        data: { ...data, userDetails: authentication.loginData },
                        actionType: DwhActionType.SuccessScreen,
                        messageText: DWHMessageText.SuccessScreenTV,
                        status: DWHStatus.Completed,
                    });
                    break;
                default:
                    break;
            }
        }
    }

    const handleSubmit = (buttonAction) => {
        showAppLoader()
        if (buttonAction) {
            buttonAction();
        };
    }

    const isShowButton = () => {
        if (authentication.loginData.userDetails.RoleList?.length == 1 &&
            (authentication.loginData.userDetails.RoleList[0] == "NEWCREDENTIALS_CELLCOM_WEB_SITE_TRANSFERCLI" || authentication.loginData.userDetails.RoleList[0] == "NEWCREDENTIALS_CELLCOM_WEB_SITE_TRANSFERSERVICES")) {
            return false;
        }
        else return true;
    }


    return (
        <div className='stepContainer ownership-transfer-step messagePage'>
            <Image src={icon} />
            <p className='l-title' dangerouslySetInnerHTML={{ __html: replacePlaceholders(title, data, isMobile) }} />
            {secondTitle && <p className='m-title' dangerouslySetInnerHTML={{ __html: replacePlaceholders(secondTitle, data, isMobile) }} />}

            <div className='continue-button'>

                {(buttonText && isShowButton()) && (
                    <BtnSubmit text={buttonText} onclick={() => handleSubmit(buttonClick)} />
                )}
                {(secondButtonText && isShowButton()) && (
                    <BtnWhiteBlackBorderBigSize
                        className={`second-button`}
                        text={secondButtonText}
                        onclick={() => handleSubmit(secondButtonClick)}
                    />
                )}
            </div>
        </div>
    )
};


const mapStateToProps = (state) => ({
    data: state.OwnershipTransferPrivateBuyer,
    authentication: state.authentication,

});

const mapDispatchToProps = { showAppLoader };
export default connect(mapStateToProps, mapDispatchToProps)(GeneralMessage);
